import './App.scss';

import React, {Component} from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { authTest, getLoggedInUser } from 'containers/AuthPages/store/actions';

import { USER_ROLES } from 'utils/constants';

import Header from 'components/Header';
import MainNav from 'components/MainNav';
import MainContent from './MainContent';

class App extends Component {
    componentWillMount() {
        //Not showing error on first load directly navigating to /login
        let showError = location.pathname !== '/login';
        this.props.authTest(showError, (hasAccess) => {
            if(hasAccess === false && location.pathname !== '/signup') {
                this.props.changeLocation('/login');
            } else if(hasAccess === true && location.pathname === '/login') {
                document.body.classList.remove('auth-page');
            } else if(location.pathname === '/') {
                document.body.classList.remove('auth-page');
                this.props.changeLocation('/assignments');
            } else if(location.pathname !== '/login' && location.pathname !== '/signup') {
                document.body.classList.remove('auth-page');
            }
            if(hasAccess === true) {
                this.props.getLoggedInUser(() => {
                    //Add class for non-admin users
                    if (this.props.auth.role !== USER_ROLES.ADMIN && this.props.auth.role !== USER_ROLES.CREATOR_ADMIN) {
                        document.body.classList.add('not-admin');
                        this.props.changeLocation('/download');
                    } else {
                        document.body.classList.remove('not-admin');
                    }
                });
            }
        });
    }

    keepSessionAlive(shouldRunAuthTest) {
        //TODO Add a "keep session alive" functionality to an authService
        if(shouldRunAuthTest === true) {
            this.props.authTest(false ,(hasAccess) => {
                if(hasAccess === true) {
                    this.props.auth.sessionTimer = setTimeout(this.keepSessionAlive.bind(this), 900000);
                }
            })
        }

    }

    render() {
        let { children, location, app, auth } = this.props;
        return (
            <div className="wrapper">
                <Header isTestingAuth={auth.isTestingAuth}
                        title={app.title}
                        user={auth.user} />
                <MainNav pathname={location.pathname} />
                <MainContent>
                    {children}
                </MainContent>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        app: state.app,
        auth: state.auth,
        location: state.routing.locationBeforeTransitions
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        authTest: (showError, callback) => dispatch(authTest(showError, callback)),
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        getLoggedInUser: (callback) => dispatch(getLoggedInUser(callback))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js